import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Technology = () => {
  return (
    <section className="technology-section">
      <div className="container">
        <h1 className="text-center">
          Tecnología = <span className="text-primary">Simplicidad</span>
        </h1>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <div
              className="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className="nav-link active"
                id="Pólizas-tab"
                data-toggle="pill"
                href="#Pólizas"
                role="tab"
                aria-controls="Pólizas"
                aria-selected="true"
              >
                Información de Pólizas
              </a>
              <a
                className="nav-link"
                id="Pagos-tab"
                data-toggle="pill"
                href="#Pagos"
                role="tab"
                aria-controls="Pagos"
                aria-selected="false"
              >
                Información de Pagos
              </a>
              <a
                className="nav-link"
                id="Historial-tab"
                data-toggle="pill"
                href="#Historial"
                role="tab"
                aria-controls="Historial"
                aria-selected="false"
              >
                Historial de Siniestros
              </a>
              <a
                className="nav-link"
                id="Endosos-tab"
                data-toggle="pill"
                href="#Endosos"
                role="tab"
                aria-controls="Endosos"
                aria-selected="false"
              >
                Endosos
              </a>
              <a
                className="nav-link"
                id="Circula-tab"
                data-toggle="pill"
                href="#Circula"
                role="tab"
                aria-controls="Circula"
                aria-selected="false"
              >
                Hoy no Circula
              </a>
              <a
                className="nav-link"
                id="Multas-tab"
                data-toggle="pill"
                href="#Multas"
                role="tab"
                aria-controls="Multas"
                aria-selected="false"
              >
                Multas
              </a>
              <a
                className="nav-link"
                id="Avisos-tab"
                data-toggle="pill"
                href="#Avisos"
                role="tab"
                aria-controls="Avisos"
                aria-selected="false"
              >
                Avisos
              </a>
            </div>
          </div>
          <div className="col-md-8 col-lg-9">
            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="Pólizas"
                role="tabpanel"
                aria-labelledby="Pólizas-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Pagos"
                role="tabpanel"
                aria-labelledby="Pagos-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Historial"
                role="tabpanel"
                aria-labelledby="Historial-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Endosos"
                role="tabpanel"
                aria-labelledby="Endosos-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Circula"
                role="tabpanel"
                aria-labelledby="Circula-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Multas"
                role="tabpanel"
                aria-labelledby="Multas-tab"
              >
                <StaticImage
                  StaticImage="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
              <div
                className="tab-pane fade"
                id="Avisos"
                role="tabpanel"
                aria-labelledby="Avisos-tab"
              >
                <StaticImage
                  src="../../../assets/images/technology.png"
                  alt="technology"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
